export const decimalRegex = /^((0(\.\d{1,2})?)|([1-9]\d*(\.\d{1,2})?))$/;

export const numbers_and_letters = /^[a-z0-9]+$/i;

export const numbers_and_leters_and_1specialcharacter = /[^A-Za-z0-9]+/;
